import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FormsModule} from '@angular/forms';
import {ReportengineModule} from '../../reportengine/reportengine.module'
import {ReportOptionsPopupComponent} from "../common/reportOptions/reportOptionsPopup/report-options-popup.component";
import {TimelineReportComponent} from "./timelinereport/timelinereport.component";
import {ReportInfoTooltipComponent} from './report-info-tooltip/report-info-tooltip.component';
import {SharedModule} from "../../../shared/shared.module";


@NgModule({
  declarations: [TimelineReportComponent, ReportInfoTooltipComponent],
  imports: [
    ReportengineModule,
    CommonModule,
    FormsModule,
    SharedModule,
  ],
  exports: []
})
export class TimelineReportModule {
}

